<template>
    <div class="login_back">
        <div class="login-header">
            <div class="login-header-left">
                <img class="logo" src="../assets/icon1.png" alt="logo" @click="onOpenUrl(10)"/>
                <span class="logo-title" @click="onOpenUrl(10)">双赛点投屏</span>
            </div>
            <span class="app-download" @click="onOpenUrl(11)">APP下载</span>
        </div>
        <div class="login-form-card">
            <div class="login-title">欢迎登录</div>
            <el-form :model="form" class="login-form">
                <el-form-item>
                    <el-input v-model="form.phone" maxlength="11" placeholder="手机号" class="phone-group">
                        <template slot="prepend">
                            <el-select v-model="form.area" class="area-select-inner" placeholder="+86" style="width: 70px">
                                <el-option label="+86" value="86" />
                            </el-select>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item> 
                    <el-input v-model="form.code" placeholder="验证码" class="code-group" maxlength="6">
                        <template slot="append">
                            <el-button class="send-code-btn" type="text" v-if="!isCounting" @click="onSendPhoneCode" :disabled="loginSending || !agree">
                                发送验证码</el-button>
                            <span class="send-code-count" v-if="isCounting">{{countdown}}</span>
                        </template>
                    </el-input>
                </el-form-item>
                
                <el-form-item>
                    <el-button class="login-btn" type="primary" @click="onLogin" :disabled="loginSending || !agree">立即登录</el-button>
                </el-form-item>
                <el-form-item class="agreement-item">
                    <el-checkbox v-model="agree" style="display:inline-block">
                        <div class="changer_sl">
                            <div style="color:#000">我已阅读并同意</div>
                            <a href="javascript:void(0)" class="link" @click="onOpenUrl(0)">《用户协议》</a>
                            <div class="link">和</div>
                            <a href="javascript:void(0)" class="link" @click="onOpenUrl(1)">《隐私条款》</a>
                        </div>
                    </el-checkbox>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mobileCodeLogin, sendMobileCode } from '@/api/user'
export default {
    data() {
        return {
            form: {
                area: '86',
                phone: '',
                code: '',
            },
            agree: false,   //是否同意协议
            loginSending: false,     //是否在发送
            phoneSend: '',      //获取到验证码的手机号码
            isCounting: false,  //倒计时
            countdown: 60,  //倒计时数字
        };
    },
    methods: {
        //验证码倒计时
        verification() {
            if (this.isCounting) {
                return;
            }
            this.isCounting = true;
            this.countdown = 60;    //赋值60秒
            const times = setInterval(() => {
                this.countdown--; //递减
                if (this.countdown === 0) {
                    // === 0 变成获取按钮
                    clearInterval(times);
                    this.isCounting = false;
                }
            }, 1000);
        },
        //发送验证码
        async onSendPhoneCode() {
            if (this.form.phone == '' || (!(/^1[345789]\d{9}$/.test(this.form.phone)))) {
                this.$alert("请输入手机号。");
                return;
            }

            this.phoneSend = this.form.phone;
            const params = {
                area: this.form.area,
                phone: this.form.phone
            }
            try {
                this.loginSending = true;
                const res = await sendMobileCode(params);
                this.loginSending = false;
                //console.log(res)
                if (res.success) {
                    // 验证码倒计时
                    this.verification();
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                this.loginSending = false;
                this.$message.error('请求失败')
            }
        },

        //登录
        async onLogin() {
            if (this.form.phone == '' || (!(/^1[345789]\d{9}$/.test(this.form.phone)))) {
                this.$alert("请输入手机号。");
                return;
            }

            if (this.form.code == '' || (!(/^[0-9]\d{5}$/.test(this.form.code)))) {
                this.$alert("请输入验证码。");
                return;
            }

            if (this.phoneSend == "") {
                this.phoneSend = this.form.phone;
            }
            const params = {
                area: this.form.area,
                phone: this.phoneSend,
                code: this.form.code,
                fromDevice: 0   //固定为0，web
            }
            try {
                this.loginSending = true;
                const res = await mobileCodeLogin(params);
                this.loginSending = false;
                //console.log(res)
                if (res.success) {
                    this.$message.success("登录成功")
                    this.$router.push('/user');
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                this.loginSending = false;
                this.$message.error('请求失败')
            }
        },

        //打开协议文件
        onOpenUrl(val) {
            if (val == 0) {
                window.open('https://user.ssscreen.cn/note/user.html', '_blank');
            } else if (val == 1) {
                window.open('https://user.ssscreen.cn/note/privacyAgreement.html', '_blank');
            } else if (val == 10) {
                window.open('https://www.ssscreen.cn/', '_blank');
            } else if (val == 11) {
                window.open('https://www.ssscreen.cn/#download', '_blank');
            }
        }
    }
};
</script>

<style scoped lang="less">
.login_back {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    min-height: 100vh;
    background: url('../assets/login_back.png');
    background-size: cover;
    .login-header {
        position: relative;
        top: 32px;
        left: 40px;
        z-index: 2;
        width: 100%;
        .login-header-left {
            display: flex;
            align-items: center;
            .logo {
                width: 40px;
                height: 40px;
                margin-right: 8px;
                cursor: pointer;
            }
            .logo-title {
                font-size: 16px;
                color: #fff;
                font-weight: bold;
                letter-spacing: 2px;
                font-family: YouSheBiaoTiHei;
                cursor: pointer;
            }
        }
        .app-download {
            position: absolute;
            right: 80px;
            top: 0;
            color: #fff;
            font-size: 16px;
            opacity: 0.8;
            cursor: pointer;
        }
    }
    .login-form-card {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 400px;
        background: #fff;
        border-radius: 18px;
        box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
        z-index: 2;
        .login-form {
            margin-top: 0;
            padding: 20px;
        }
        .el-form-item {
            margin-bottom: 22px;
            align-items: center;
        }
        .area-select {
            margin-right: 8px;
        }
        .phone-input {
            flex: 1;
        }
        .code-input {
            flex: 1;
            margin-right: 8px;
        }
        .send-code-btn {
            color: #EE71A7;
            font-weight: 400;
            padding: 0 8px;
            width: 90px;
        }
        .send-code-count {
            font-weight: 400;
            margin: -10px -20px;
            width: 90px;
            display: inline-block;
            text-align: center;
        }
        .login-btn {
            width: 100%;
            background: #EE71A7;
            border: none;
            font-size: 18px;
            font-weight: 600;
            border-radius: 8px;
            height: 44px;
            margin-top: 8px;
        }
        .login-btn:hover {
            background: #ffb6d5;
        }
        .agreement-item {
            margin-bottom: 0;
            font-size: 13px;
            color: #999;
            display: block;
            display: flex;
            .changer_sl {
                display: flex;
                .link {
                    color: #EE71A7;
                    text-decoration: none;
                    margin: 0 2px;
                    font-weight: 400;
                }
            }
        }
        .login-title {
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            color: #222;
            padding: 20px 0;
        }
    }
}
</style>
